import { UIComponentState, UIDataModel, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { HomeViewImpl } from './homeview';
import { HomeCSSStyleImpl } from './homecss';
import { FeaturedCategoryDto } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { CategoryDto } from '../../../../core/dto/categories/categorydto';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { HomeAPIModelImpl, HomeAPIModel } from './homeapimodel';
import { BannerDto } from '../../../../core/dto/banner/bannerdto';
import { CRBTUIComponent, CRBTUIComponentProps } from '../crbt/crbtuicomponent';
import { SubscriptionPlanDetailsDto, SubscriptionPlanDetailsDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscriptionplandetails/subscriptionplandetailsdto';
import { RoutingFeatures } from '../../navigation/routingfeature';

export interface HomeComponentProps extends CRBTUIComponentProps
{
    onBannerClick(bannerDto: BannerDto): void;
}

export interface HomeComponentState extends UIComponentState
{
    isConfiguartionLoaded: boolean;
    // listOfFeaturedCategories: FeaturedCategoryDto[];
    listOfCategories: CategoryDto[];
    listOfBannerDtos: BannerDto[];
    subscriptionPlanDetailsDto: SubscriptionPlanDetailsDto;

}

export interface HomeComponentHandler extends UIComponentHandler
{
    onSearchClick(searchKey: string):void;
    onSpecificSearchClick(searchKey:string,type:string):void;
    loadMoreFeaturedCategoryTones(featuredCategoryDto: FeaturedCategoryDto, startIndex: number, offset: number): void;
}

export class HomeComponent extends CRBTUIComponent<HomeComponentProps, HomeComponentState> 
implements HomeComponentHandler
{
    constructor(props: HomeComponentProps)
    {
        super(props);
         console.log("home component invoked&&&&&");
        this.state = {isConfiguartionLoaded: false, listOfCategories: [], listOfBannerDtos: [],subscriptionPlanDetailsDto: new SubscriptionPlanDetailsDtoImpl()};

    }

    
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        

        if(!this.props.context.getUserContext().getIsLoggedIn())
        {
            history.pushState(null, location.href);
                window.onpopstate = function () {
                    history.go(1);
                };
        }
    }

    componentDidMount()
    {        
        this.getAPIModel().getSettings();

        window.scrollTo(0,0);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new HomeViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new HomeCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new HomeAPIModelImpl(applicationContext, apiModelHandler);
    }

    loadMoreFeaturedCategoryTones(featuredCategoryDto: FeaturedCategoryDto, startIndex: number, offset: number): void 
    {
        this.getAPIModel().getLoadMoreFeatureCategoriesTones(featuredCategoryDto, startIndex, offset);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.SETTINGS)
        {
            this.setState({isConfiguartionLoaded: true});
            
            this.getAPIModel().getBanners();
            this.getAPIModel().getSubscriptionPlanDetails();
        }
        else if(feature === APIFeatures.CATEGORIES)
        {
            this.setState({listOfCategories: data as CategoryDto[]});
        }
        // else if(feature === APIFeatures.LOAD_MORE_TONES)
        // {
        //     (this.getView() as HomeViewImpl).setLoadMoreData((data as FeaturedCategoryDto).getTitle(),
        //                     (data as FeaturedCategoryDto).getListOfTones());
        // }
        else if(feature === APIFeatures.BANNER)
        {
            this.setState({listOfBannerDtos: (data as BannerDto[])});     
        }
        else if(feature === APIFeatures.SUBSCRIPTION_PLAN_DETAILS)
        {
            this.setState({subscriptionPlanDetailsDto:data as SubscriptionPlanDetailsDto});
        }

        window.scrollTo(0,0);
    }

    onSearchClick(searchKey: string):void
    {
        searchKey = searchKey.trim();
        this.props.routeNextFeature(RoutingFeatures.NAME_TUNES + "?searchkey=" + searchKey, false);

    }

    onSpecificSearchClick(searchKey:string, type:string):void
    {
        searchKey = searchKey.trim();
        this.props.routeNextFeature(RoutingFeatures.SEARCH_LIST + "?searchkey=" + searchKey + "&type=" + type, false);
    }
    getAPIModel(): HomeAPIModel
    {
        return (super.getAPIModel() as HomeAPIModel);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homecomponent.tsx